import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/content';
import { offer } from '../data/offer';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 9000;
export function PurchasePopups() {
  const [index, setIndex] = useState<number | null>(null);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed || recentPurchases.length === 0) return;
    let i = 0;
    let hideTimer: number;
    const show = () => {
      setIndex(i % recentPurchases.length);
      i += 1;
      hideTimer = window.setTimeout(() => setIndex(null), VISIBLE_FOR);
    };
    const first = window.setTimeout(show, FIRST_DELAY);
    const loop = window.setInterval(show, VISIBLE_FOR + GAP);
    return () => {
      window.clearTimeout(first);
      window.clearTimeout(hideTimer);
      window.clearInterval(loop);
    };
  }, [dismissed]);
  const item = index !== null ? recentPurchases[index] : null;
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-250" data-mp="cgxea4vz0kf">
      <AnimatePresence data-id="element-251" data-mp="3ht8gr3xx6dih">
        {item && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full items-center gap-3 rounded-2xl border border-line bg-cream p-3 pr-10 shadow-2xl sm:w-[340px]" data-id="element-252" data-mp="3hurxevnhmqks">
            <img src={offer.mockupImage} alt="" className="h-14 w-14 shrink-0 rounded-xl bg-white object-contain" data-id="element-253" data-mp="9d5ejdpkth1j" />
            <div className="min-w-0" data-id="element-254" data-mp="2q19fq35x8kiz">
              <p className="truncate text-sm font-black text-ink" data-id="element-255" data-mp="2q07uj5v6yhnj">
                {item.name} de {item.country}
              </p>
              <p className="text-sm text-ink/80" data-id="element-256" data-mp="2u11j81ggk0hh">compró el MegaPack Antipantallas</p>
              <p className="mt-0.5 flex items-center gap-1 text-xs font-bold text-brand-deep" data-id="element-257" data-mp="10mqb6ffmy51o">
                <ShoppingBagIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-258" data-mp="vnni7tcxjpa2" />
                {item.when}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificaciones" className="absolute right-2 top-2 rounded-full p-1 text-ink/50 transition-colors duration-150 hover:text-ink" data-id="element-259" data-mp="lwaqd1r4sz41">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-260" data-mp="7vzzvztqhmje" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}